import { useQuery } from "@tanstack/react-query";
import { AxiosResponse } from "axios";
import { customAxios } from "lib/axios";
import type { IssueComment } from "types";

export async function typedCustomAxiosGet<T>(url: string): Promise<T> {
  const response: AxiosResponse<T> = await customAxios.get<T>(url);
  return response.data;
}

const fetchCommentsByIssue = async (issueId: string): Promise<IssueComment[]> =>
  typedCustomAxiosGet<IssueComment[]>(`/comments/issue/${issueId}`);

export const useCommentsByIssue = (issueId: string | undefined) =>
  useQuery<IssueComment[], Error>({
    queryKey: ["comments", issueId],
    queryFn: () =>
      issueId ? fetchCommentsByIssue(issueId) : Promise.resolve([]),
    enabled: !!issueId,
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
  });
